import { FC } from 'react';
import { IOption } from 'components/elements/CustomSelect';
import { CustomModal } from 'components/elements/CustomModal';
import { AliasForm, IAliasFormValues } from '../AliasForm';

export type { IAliasFormValues } from '../AliasForm';

interface ManageAliasModalProps {
	isOpen: boolean;
	onClose: () => void;
	initialValues: IAliasFormValues;
	initialCityTitle?: string;
	onSubmit: (values: IAliasFormValues) => void;
	cityOptions: IOption[];
	cityOptionsLoading: boolean;
	onCitySearch: (search: string) => void;
	onCityLoadMore: () => void;
	hasMoreCityOptions: boolean;
	buttonText: string;
	title: string;
}

export const ManageAliasModal: FC<ManageAliasModalProps> = ({
	isOpen,
	onClose,
	initialValues,
	initialCityTitle,
	onSubmit,
	cityOptions,
	cityOptionsLoading,
	onCitySearch,
	onCityLoadMore,
	hasMoreCityOptions,
	buttonText,
	title,
}) => {
	return (
		<CustomModal open={isOpen} onClose={onClose} title={title} maxWidth="md" fullWidth>
			<AliasForm
				initialValues={initialValues}
				initialCityTitle={initialCityTitle}
				onSubmit={onSubmit}
				buttonText={buttonText}
				cityOptions={cityOptions}
				cityOptionsLoading={cityOptionsLoading}
				onCitySearch={onCitySearch}
				onCityLoadMore={onCityLoadMore}
				hasMoreCityOptions={hasMoreCityOptions}
			/>
		</CustomModal>
	);
};
